"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifierComponent = void 0;
const core_1 = require("@angular/core");
const notifier_service_1 = require("./notifier.service");
const router_1 = require("@angular/router");
let NotifierComponent = class NotifierComponent {
    constructor(_notifier, _router) {
        this._notifier = _notifier;
        this._router = _router;
        this.showContent = true;
    }
    ngOnInit() {
        this._notifier.emitter.subscribe(this.onLoadedNotificationsChange.bind(this));
    }
    onLoadedNotificationsChange(event) {
        //Update the notifications
        this.notifications = this._notifier.getLoadedNotifications();
        if (this.notifications.length < 1) {
            this._notifier.close();
        }
    }
};
exports.NotifierComponent = NotifierComponent;
exports.NotifierComponent = NotifierComponent = __decorate([
    (0, core_1.Component)({
        selector: 'notifier',
        styleUrls: ['styles/less/notifier.component.less'],
        templateUrl: 'app/notifier.component.html'
    }),
    __metadata("design:paramtypes", [notifier_service_1.NotifierService,
        router_1.Router])
], NotifierComponent);
//# sourceMappingURL=notifier.component.js.map